'use client';

import * as Dialog from '@radix-ui/react-dialog';
import { CaretLeft, CaretRight, X } from 'phosphor-icons';
import { c } from '../../../utils/tailwind-merge';
import { SheetsProps } from './Sheets.types';

export const Sheets = ({
  label,
  parentSheetsTitle,
  nestedModal,
  isFirstItem,
  children,
  open,
  onOpenChange,
  microcopy,
  className = '',
  contentClassName = '',
}: SheetsProps) => {
  const handleCloseAll = async (e: React.MouseEvent<SVGSVGElement>) => {
    e.preventDefault();
    const openDialogs = document.querySelectorAll('[data-state="open"]');
    openDialogs.forEach((dialog) =>
      dialog.setAttribute('data-state', 'closed')
    );
    await new Promise((resolve) => setTimeout(resolve, 300));
    (document.getElementById('close-all') as HTMLElement)?.click();
  };

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Trigger asChild className={className}>
        <button className="w-full">
          <div
            className={c(
              'flex items-center justify-between border-b border-grey-300 p-3',
              isFirstItem ? 'border-t' : ''
            )}
          >
            <span className="text-grey-700">{label}</span>
            <CaretRight className="h-6 w-6 text-grey-600" />
          </div>
        </button>
      </Dialog.Trigger>

      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/30 transition-opacity duration-300" />
        <Dialog.Content
          className={c(
            'fixed right-0 top-0 z-50 h-full w-full max-w-md overflow-auto bg-white shadow-lg',
            'transition-transform duration-300 ease-in-out',
            'data-[state=closed]:animate-slideOut data-[state=open]:animate-slideIn'
          )}
        >
          <div className="flex items-center justify-between border-b border-grey-300 px-2 py-3">
            <div className="flex flex-row items-center">
              <Dialog.Close asChild>
                <CaretLeft
                  className="h-6 w-6 cursor-pointer"
                  aria-label="Close"
                />
              </Dialog.Close>
              <Dialog.Title className="ml-2 text-base text-grey-700">
                {parentSheetsTitle ?? label}
              </Dialog.Title>
            </div>
            <Dialog.Close asChild>
              <div className="flex flex-row items-center" id="close-all">
                <X
                  className="h-6 w-6 cursor-pointer text-grey-900"
                  aria-label={microcopy?.close}
                  onClick={handleCloseAll}
                />
              </div>
            </Dialog.Close>
          </div>

          <div className={c('', children ? 'px-2.5' : '', contentClassName)}>
            {children ?? nestedModal}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
